import siteUrl from '@/utils/url/site'
export default async (args = {}) => {
  const carousel = [], names = []
  servicos.forEach(i => {
    carousel.push({
      image: 'src/fotos/servicos/' + i.image,
      actions: {
        color: "error darken-2",
        icon: "chart-areaspline",
        text: i.name,
        action: siteUrl('servicos/' + i.lnk)
      }
    });
    names.push('<strong>' + i.name + '</strong>')
  });
  const total = names.length - 1, ultimo = names[total]
  delete names[total]
  const areas = names.join(", ") + ' e ' + ultimo;
  return {
    msg: `<div class="mb-2">Nós atuamos nas áreas de ${areas}.<br><span class="error--text">Você pode encontrar mais informações nos links abaixo.</span></div>`,
    carousel
  }
}
